import { moveToLink } from './moveToLink';
import { isWebview } from './isWebview';

/**
 * close 딥링크를 실행
 */
export const closeWebView = () => {
  if (isWebview()) {
    moveToLink('socar-internal://close');
  } else {
    window.close();
  }
};
